import { cn } from '@commenda/utils';
import React from 'react';

import { Badge, type BadgeProps } from '../../Badge';
import { CountryFlag } from '../../Icons';
import { TruncatedText } from '../../TruncatedText';

export interface DataGridCellEntityBadge {
  label: React.ReactNode;
  variant?: BadgeProps['variant'];
}

export interface DataGridCellEntityProps {
  children: React.ReactNode;
  countryCode?: string;
  badge?: DataGridCellEntityBadge;
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
  className?: string;
}

const DATA_GRID_CELL_FLAG_STYLE: React.CSSProperties = {
  width: 24,
  height: 24,
};

const DataGridCellEntity = ({
  children,
  countryCode,
  badge,
  leading,
  trailing,
  className,
}: DataGridCellEntityProps) => (
  <div className={cn('flex w-full items-center gap-lg', className)}>
    {leading}
    {countryCode ? (
      <CountryFlag
        countryCode={countryCode}
        svg
        alt=""
        className="shrink-0 rounded-full object-cover"
        style={DATA_GRID_CELL_FLAG_STYLE}
      />
    ) : null}
    <TruncatedText className="txt-small-regular text-text-primary">
      {children}
    </TruncatedText>
    {badge ? (
      <Badge size="sm" variant={badge.variant}>
        {badge.label}
      </Badge>
    ) : null}
    {trailing}
  </div>
);

export { DataGridCellEntity };
